import React, { useState, useEffect } from 'react';
import { Grid, FormControl, InputLabel, MenuItem, Typography, Button } from '@mui/material';
import styled from '@mui/material/styles/styled';
import { UseScreen } from '../hooks/UseScreen.hook';
import { useDispatch, useSelector } from 'react-redux';
import SuccessModal from '../components/SuccessModal';
import { useNavigate } from 'react-router-dom';
import { CashCloseTable } from '../components/datatables/index'
import { PrimaryOutlinedButton, PrimaryLightInput, SecondaryOutlinedButton } from '../theme/index';

const Room = styled(Grid)(({ theme }) => `
    :hover{
      cursor: pointer
    }
`)

const createReservationRoute = '/bookings';

const CashClose = () => {

  const screenWidth = UseScreen();
  const dispatch = useDispatch();
  const modalStatus = useSelector( state => state.Modal.modalState );
  const navigate = useNavigate();

  const [ showModal, setShowModal ] = useState(false);
  const [ closeMount, setCloseMount ] = useState(0);

  useEffect( () => {
    setShowModal(modalStatus);
  }, [modalStatus] );

  const tablesTitle = () => {
    return ( screenWidth <= 500 ) ? { fontSize: '1.5rem', fontFamily: 'Roboto-Bold'  } : { fontSize: '2rem', fontFamily: 'Roboto-Bold'  };
  }
  
  return (
    <Grid container px={4}>
      <Grid item xs={12}>
        <h2 style={{ fontFamily: 'Roboto-Thin' }}>Cierre de caja</h2>
      </Grid>
      {
        showModal &&
          <SuccessModal view='cleaningRoom' />
      }

      <Grid container sx={{ mt: 5, justifyContent: 'center', mb: 8 }}>
        <Grid item xs={12} sm={8} md={5} sx={ (theme) => ({
            color: '#000', mb: 4, border: `1px solid ${theme.palette.primary.main}`
        }) }>
          <Typography sx={{ backgroundColor: 'primary.light', width: '100%', my: 0, textAlign: 'center', 
                            py: .5, color: '#FFF', fontSize: '1.5rem', fontFamily: 'Roboto-Bold' }}>
            Cierre de caja 
          </Typography>
          <Grid container style={{ display: 'flex', alignItems: 'center', textAlign: 'center', padding: '1.5rem 0' }}>
            <Grid item xs={4} style={{ display: 'inline', width: '100%' }}>
              <Typography sx={{ width: '100%', textAlign: 'start', py: .5, px: 1, color: '#000'}}>
                Monto de cierre:
              </Typography>
            </Grid>
            <Grid item xs={7} sx={{ width: '100%', textAlign: 'start', pl: 1 }}>
              <PrimaryLightInput type='number' sx={{ width: '100%' }} value={closeMount} onChange={ e => setCloseMount(e.target.value) } />
            </Grid>
          </Grid>
          <Grid container sx={{ justifyContent: 'space-between', px: 1, py: 2 }}>
            <Grid item xs={12} md={5} sx={{ mb: 2 }}>
              <SecondaryOutlinedButton sx={{ width: '100%', fontFamily: 'Roboto-Medium' }} onClick={ () => setCloseMount(0) }>Limpiar</SecondaryOutlinedButton>
            </Grid>
            <Grid item xs={12} md={5}>
              <PrimaryOutlinedButton sx={{ width: '100%', textTransform: 'none', fontFamily: 'Roboto-Medium' }}>Cerrar caja</PrimaryOutlinedButton>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12} sx={{ mb: 4, textAlign: 'center' }}>
        <Typography sx={{ }}>
                Cajas cerradas hoy
        </Typography>
      </Grid>
      <Grid item xs={12} sx={{ mb: 4 }}>
        <CashCloseTable />
      </Grid>
    </Grid>
  )
}

export default CashClose